export enum CorporateCompanyPageView {
  AssignedUsers = 'users',
  CorporateCompanies = 'companies',
}
